module.exports = __webpack_public_path__ + "static/media/AMX-Medium.9bf1ac53.ttf";